import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import TransactionTable from '../../AppGrid/TransactionTable';
import { useBreadcrumbs } from '../../contexts/Breadcrumbs';
import strings from '../../Globalization/index';
import { useUniqueEffect } from '../../hooks';

const EndoScopeTransactionList = () => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const [searchParams] = useSearchParams();
	const endoScopeId = searchParams.get('EndoScopeId');
	useUniqueEffect(() => {
		setBreadcrumbs({
			breadcrumbs: [{ text: strings.EndoScopeDetail }],
			docTitle: strings.EndoScopeDetail,
		});
	}, [breadcrumbs, strings.EndoScopeDetail]);
	const parentFilters = useMemo(() => {
		return {
			filter: [{ operator: '$eq', value: endoScopeId, property: 'EndoScopeId', type: 'numeric' }],
		};
	}, [endoScopeId]);
	return (
		<Grid container>
			<Grid size={12}>
				<TransactionTable parentFilters={parentFilters} />
			</Grid>
		</Grid>
	);
};
export default EndoScopeTransactionList;
